<template>
  <div class="container">
    <!-- 体检人信息 -->
    <div class="person-wrapper">
      <div class="person-avatar">
        <img src="@/assets/images/avatar-male.png" v-if="userProfile.sex ==1" />
        <img src="@/assets/images/avatar-female.png" v-else />
      </div>
      <div class="person-info">
        <span class="person-name">{{userProfile.name}}</span>
        &nbsp;
        <span style="font-weight:normal;color:#99999;">{{userProfile.mobile| mask("phone")}}</span>
        <div class="person-idcard">
          身份证号：
          <span>{{userProfile.idcard | mask("idcard")}}</span>
        </div>
      </div>
    </div>

    <!-- 套餐明细 -->
    <div class="product-wrapper">
      <h3>套餐详细</h3>
      <div class="product-detail" v-if="!customized">
        <div class="product-row">
          <p class="item-type">套餐</p>
          <p class="item-name">{{package.name}}</p>
          <p class="item-price">￥{{package.sale_price}}</p>
        </div>
        <div class="product-row" v-for="(item,index) in order.package.items" :key="index">
          <ul>
            <li class="title">
              <span v-if="item.items">加项包</span>
              <span v-else>加项</span>
            </li>
            <li class="content">
              {{item.name}}
              <span v-if="item.items && item.items.length>0">（共{{item.items.length}}项）</span>
            </li>
            <li class="price">￥{{item.price}}</li>
            <div class="clb"></div>
          </ul>
        </div>
      </div>
      <div class="product-detail" v-else>
        <div class="product-row">
          <p class="item-type">套餐</p>
          <p class="item-name">{{customizedProject.packageName}}</p>
          <p class="item-price">￥{{customizedProject.packagePrice}}</p>
        </div>
        <div class="product-row" v-for="(combo,index) in customizedProject.addCombos" :key="'combo_'+index">
          <p class="item-type">组合</p>
          <p class="item-name">{{combo.comboName}}</p>
          <p class="item-price">￥{{combo.price}}</p>
        </div>
        <div class="product-row" v-for="(item,index) in customizedProject.addItems" :key="'item_'+index">
          <p class="item-type">加项</p>
          <p class="item-name">{{item.name}}</p>
          <p class="item-price">￥{{item.price}}</p>
        </div>
      </div>
      <div class="product-total">
        合计：
        <p class="price">￥{{Number(totalAmount).toFixed(2)}}</p>
      </div>
    </div>

    <!-- 预约体检时间 -->
    <div class="appoint-wrapper">
      <!-- 体检时间选择 -->
      <van-cell title="体检日期" icon="clock-o" is-link palceholder="请选择" @click="selectDate()"
        :value="orderDateTime?orderDateTime:'请选择'" />
    </div>

    <!-- 支付方式 -->
    <div class="payment-wrapper">
      <van-radio-group v-model="paymentType">
        <van-cell-group>
          <van-cell title="现场支付" icon="balance-pay" clickable @click="paymentType = 0" v-if="show_default_payment">
            <template #right-icon>
              <van-radio :name="0" />
            </template>
          </van-cell>
          <van-cell v-for="(payment,index) in payments" :key="payment.id" :title="payment.name" icon="wechat-pay"
            clickable @click="paymentType = payment.id">
            <template #right-icon>
              <van-radio :name="payment.id" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <van-notice-bar v-if="paymentRemark != ''" wrapable :scrollable="false" :text="paymentRemark" />
    </div>
    <!-- 可选项：华东医院显示是否订制 -->
    <div class="option-wrapper" v-if="show_additem_option">
      <van-field name="switch" label="需要订制加项" input-align="right">
        <template #input>
          <van-switch v-model="flag_add_item" size="20" />
        </template>
      </van-field>
      <div class="option-remark">医生将电话联系您，分析个人情况后订制加项</div>
    </div>

    <!-- 可选项：瑞金医院，显示支付选项 -->
    <div class="option-wrapper" v-if="show_payment_options">
      <van-radio-group v-model="input_payment_selection">
        <van-cell-group>
          <van-cell title="银行卡" clickable @click="input_payment_selection = '银行卡'">
            <template #right-icon>
              <van-radio name="银行卡" />
            </template>
          </van-cell>
          <van-cell title="储值卡" clickable @click="input_payment_selection = '储值卡'">
            <template #right-icon>
              <van-radio name="储值卡" />
            </template>
          </van-cell>
          <van-cell title="保险" clickable @click="input_payment_selection = '保险'">
            <template #right-icon>
              <van-radio name="保险" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </div>

    <!-- 可选项：建工医院，显示单位名称 -->
    <div class="option-wrapper" v-if="show_company_name_input">
      <!-- <van-field v-model="input_company_name" label="单位名称" placeholder="请填写所属单位名称，必埴" /> -->
      <van-field readonly clickable label="单位名称" :value="input_company_name" placeholder="请选择单位名称，必埴"
        @click="showCompanyPicker = true" />
      <van-popup v-model="showCompanyPicker" round position="bottom">
        <van-picker show-toolbar :columns="company_name_options" @cancel="showCompanyPicker = false"
          @confirm="onSelectCompany" />
      </van-popup>
    </div>

    <!-- 底部按钮 -->
    <div class="footer fixed-footer">
      <van-button class="submit-button" :disabled="!orderDateTime || isLoading" :loading="isLoading" loading-text="正在保存……"
        @click="submitOrder()" type="info" size="large">确认预约</van-button>
    </div>
    <!-- 选择日期组件，弹窗显示 -->
    <van-popup v-model="showCalendar" round position="bottom" :style="{ height: '600px' }">
      <van-calendar type="single" :poppable="false" :formatter="formatter" color="var(--color-main)" row-height="56"
        :show-title="false" first-day-of-week="1" @select="onSelectDay">
        <slot slot="footer" name="footer" class="calendar-footer">
          <div style="height:170px" v-if="dateDisableReason == ''">
            <div class="timeRanges-title"><span class="timeRanges-title--left">请选择时间段</span>
              <span class="timeRanges-title--right">
                共{{timeRanges.length}}个</span></div>
            <ul class="timeRanges" v-if="timeRanges && timeRanges.length>0">
              <li v-for="tr in timeRanges" class="time-item"
                :class="{'time-item--disabled':tr.limitNum==0 || tr.limitNum<=tr.orderNum || !tr.orderable,'time-item--selected': tr == orderTime}"
                @click="setOrderTime(tr)" ref="timeItems">
                {{tr.timeRangeName}}
                <p v-if="tr.limitNum==0 || tr.limitNum<=tr.orderNum || !tr.orderable">不可预约</p>
                <p v-else>可预约</p>
              </li>
            </ul>
            <div class="confirm-btn-wrap">
              <van-button size="large" type="info" @click="setOrderDateTime()" :disabled="!orderDate || !orderTime">确定
              </van-button>
            </div>
          </div>
          <div style="height:170px" v-else>
            <p style="padding:60px 0;text-align:center;font-size:16px">{{dateDisableReason}}</p>
          </div>
        </slot>
      </van-calendar>
    </van-popup>


  </div>
</template>

<style lang="less" scoped>
  .container {
    padding-bottom: 80px;
  }

  .person-wrapper {
    padding: 12px 24px;
    margin-bottom: 12px;
    display: flex;
    background: #fff;

    img {
      width: 60px;
      height: 60px;
      margin-right: 24px;
    }

    .person-info {
      flex: 1;

      .person-name {
        font-size: 16px;
        margin-bottom: 12px;
      }

      .person-idcard {
        margin-top: 12px;
        font-size: 14px;
        color: #623233;
      }
    }
  }

  .appoint-wrapper {
    margin-bottom: 12px;

    /deep/ .van-cell__value {
      color: rgb(43, 44, 44);
      font-weight: 600;
      font-size: 16px;
      overflow: visible;

    }
  }

  .option-wrapper {
    min-height: 24px;
    background: #fff;
    margin-bottom: 12px;

    .option-remark {
      font-size: 14px;
      font-weight: 300;
      color: #969799;
      padding: 8px 16px;
    }
  }

  .payment-wrapper {
    margin-bottom: 12px;

    /deep/.van-cell__left-icon {
      color: #4ec963;
    }

    .icon-wechat-pay {
      color: green;
    }

    .icon-balance-pay {
      color: green;
    }
  }

  .product-wrapper {
    padding: 12px;
    background: #fff;
    margin-bottom: 12px;

    h3 {
      line-height: 32px;
      border-bottom: 1px solid #ebedf0;
    }

    .product-detail {
      .product-row {
        display: flex;
        font-size: 14px;
        padding: 10px 0;

        .item-type {
          width: 80px;
        }

        .item-name {
          flex: 1;
        }

        .item-price {
          width: 80px;
          text-align: right;
        }
      }
    }

    .product-total {
      font-size: 14px;
      text-align: right;
      padding: 8px 0;
      border-top: 1px solid #ebedf0;

      .price {
        display: inline-block;
        font-size: 16px;
        color: #f63;
      }

      .price:first-letter {
        font-size: 14px;
      }
    }
  }

  .footer {
    background-color: transparent;
    padding: 8px;

    .submit-button {
      width: 100%;

    }
  }

  /deep/ .van-cell__value {
    white-space: nowrap;
  }

  /deep/ .van-calendar__popup.van-popup--bottom {
    height: 600px !important;
  }

  /deep/ .van-calendar__footer {
    box-shadow: 0 -2px 10px rgba(125, 126, 128, 0.16);
    padding: 12px 0px;
    position: relative;

    .timeRanges-title {
      padding: 0px 12px;
      display: flex;
      line-height: 24px;

      .timeRanges-title--left {
        flex: 1
      }

      .timeRanges-title--right {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.5);

      }
    }

    .timeRanges {
      //display: flex;
      //flex-wrap: nowrap;
      //justify-content: space-between;
      overflow-x: auto;
      padding: 12px;
      position: relative;
      margin: 0;
      -webkit-overflow-scrolling: touch;
      white-space: nowrap;
      overflow-x: scroll;
      -webkit-overflow-scrolling: touch;
      padding-bottom: 10px;

      .time-item {
        //flex: 1;
        display: inline-block;
        width: calc((100% - 70px)/ 3);
        font-size: 12px;
        padding: 8px 0px;
        border-radius: 5px;
        border: 1px solid #cccccc;
        //border: 1px solid #fafafa;
        background-color: #fafafa;
        margin-right: 10px;
        text-align: center;

        p {
          font-size: 12px;
          margin-top: 6px;
          font-weight: 400;
        }
      }

      .time-item--disabled {
        color: #b5b5b5;

        p {
          color: #b5b5b5;
        }
      }

      .time-item--selected {
        border: 1px solid #0e95dd;
        background-color: #f0f7fa;
        color: #169bd5;

        p {
          color: #0e95dd;
        }
      }
    }

    .confirm-btn-wrap {
      padding: 12px 12px 0;
    }

    .appoint-time {
      line-height: 32px;
      color: var(--color-main);
      margin-bottom: 16px;
    }
  }

  /deep/ .van-radio__icon--checked {
    .van-icon {
      line-height: 1;
    }
  }
</style>

<script>
  import Vue from "vue";
  import {
    mapState,
    mapMutations,
    mapActions
  } from 'vuex'
  import moment from 'moment';
  import * as sch_api from '@/api/schedule';
  import * as order_api from '@/api/order';
  import {
    getConfigs
  } from '@/api/hospital';
  import {
    Calendar
  } from "vant";

  Vue.use(Calendar);
  const order = {
    customer: {},
    package: {},
    appointment: {}
  };
  export default {
    data() {
      return {
        customized: false, //是否为订制方案
        order: order,
        paymentType: 0,
        datePopup: false,
        showCalendar: false,
        daySchedules: [],
        timeRanges: [],
        orderDate: null,
        orderTime: null,
        dateDisableReason: "请选择日期", //日期不可预约原因
        scheduleQueryParam: {
          hospId: this.$route.query.hospid,
          examTypeId: '',
          packageId: '',
          items: '',
          age: 0,
          sex: 0,
          total: 0,
          startDate: '',
          endDate: ''
        },
        isLoading: false, //保存按钮是否处于Loading状态
        payments: [], //支付方式
        show_additem_option: false, //是否显示订制加项选项
        flag_add_item: false,
        show_company_name_input: false, //是否显示单位名称文本框
        company_name_options: [],
        input_company_name: '', //单位名称（建工医院）
        showCompanyPicker: false,
        show_payment_options: false,
        show_default_payment: true, //是否显示“现场支付选项”
        input_payment_selection: '', //瑞金特需，界面增加支付选项
        order_extra_data: {}, //订单扩展数据
        userOrder: {}, //准备提交的用户订单信息
      };
    },
    computed: {
      ...mapState({
        userProfile: state => state.user.activeUserProfile,
        package: state => state.order.package,
        customizedProject: state => state.order.customizedProject,
      }),
      totalAmount() {
        let amount = 0;
        if (this.customized) {
          amount = this.customizedProject.packagePrice;
          this.customizedProject.addItems.forEach(it => {
            amount += it.price;
          });
          this.customizedProject.addCombos.forEach(it => {
            amount += it.price;
          });
        } else {
          amount = this.package.sale_price;
        }
        return amount;
      },
      orderDateTime() {
        if (!this.orderDate || !this.orderTime || !this.orderDate || !this.orderTime.timeRangeName) {
          return null
        } else {
          return this.orderDate + " " + this.orderTime.timeRangeName
        }
      },
      paymentRemark() {
        if (this.paymentType == 0) {
          return ""
        } else {
          var payment = this.payments.find(it => {
            return it.id == this.paymentType
          });
          if (payment && payment.remark) {
            return payment.remark;
          } else {
            return ""
          }
        }
      }
    },
    mounted() {
      if (!this.userProfile) {
        this.$router.push("/");
      }
      this.customized = this.$route.query.customized == '1';
      this.createOrder();
      //获取支付方式
      order_api.getPayments(this.$route.query.hospid).then(res => {
        this.payments = res;
        this.loadConfigs();
      })
    },
    methods: {
      //加载自定义配置
      loadConfigs() {
        //获取界面配置
        getConfigs(this.$route.query.hospid).then(res => {
          let configs = res.data;
          let config = configs.find(it => {
            return it.code === 'show_additem_option'
          });
          if (config && config.value === '是') {
            this.show_additem_option = true;
          } else {
            this.show_additem_option = false;
          }

          //是否显示单位名称输入框 
          let config_show_company_name = configs.find(it => {
            return it.code === 'show_company_name_input'
          });
          if (config_show_company_name && config_show_company_name.value === '是') {
            this.company_name_options = config_show_company_name.detail_note.split('|');
            this.show_company_name_input = true;
          } else {
            this.show_company_name_input = false;
          }

          //是否显示支付选项，瑞金特需
          let config_show_payment_options = configs.find(it => {
            return it.code === 'show_payment_options'
          });
          if (config_show_payment_options && config_show_payment_options.value === '是') {
            this.show_payment_options = true;
          } else {
            this.show_payment_options = false;
          }

          //是否显示默认的“现场支付”选项
          let config_show_default_payment = configs.find(it => {
            return it.code === 'show_default_payment'
          });
          if (config_show_default_payment && config_show_default_payment.value === '否') {
            this.show_default_payment = false;
          } else {
            this.show_default_payment = true;
            this.paymentType = 0;
          }

          //判断是否选中任何支付方式
          if (!this.show_default_payment) {
            if (this.payments.length == 0) {
              this.$toast.fail("未配置支付方式");
            } else {
              this.paymentType = this.payments[0].id;
            }
          }
        })
      },
      getAge(birth) {
        var now = new Date();
        var today = moment(now).format("YYYYMMDD");

        var age = parseInt(today.substr(0, 4)) - parseInt(birth.substr(0, 4));
        if (today.substr(4, 4) < birth.substr(4, 4)) {
          age--;
        }
        return age;
      },
      onSelectCompany(value) {
        this.showCompanyPicker = false;
        this.input_company_name = value
      },
      createOrder() {
        var packageId = this.customized ? this.customizedProject.packageId : this.package.xh;
        var packageName = this.customized ? this.customizedProject.packageName : this.package.name;
        var userOrder = {
          appointStatus: 0,
          hospId: this.$route.query.hospid,
          idcard: this.userProfile.idcard,
          marital: this.userProfile.marital,
          mobile: this.userProfile.phone,
          name: this.userProfile.name,
          orderNo: '',
          orderSource: 0,
          packageId: packageId,
          packageName: packageName,
          payment: this.paymentType,
          payStatus: 0,
          sex: this.userProfile.sex,
          totalPrice: this.totalAmount,
          userAccountId: this.userProfile.account_id,
          userProfileId: this.userProfile.id,
          userSurveyId: this.customized ? this.customizedProject.userSurveyId : 0,
          package: this.package,
          customized: this.customized,
          customizedProject: this.customizedProject,
          extraData: JSON.stringify(this.order_extra_data),
        };
        order_api.createOrder(userOrder).then(res => {
          console.log(res);
          if (res.code == 200) {
            this.userOrder = res.data;
          } else {
            this.$Dialog.alert({
              title: '预约失败',
              message: res.msg,
            }).then(() => {
              this.$router.go(-1);
            });
            this.isLoading = false;
            // this.$toast.fail(res.msg);
          }
        })
      },
      submitOrder() {
        this.userOrder.appointDate = this.orderDate;
        this.userOrder.appointPeriod = this.orderTime.period;
        this.userOrder.appointTimeRangeId = this.orderTime.timeRangeId;
        this.userOrder.appointTimeRangeName = this.orderTime.timeRangeName;
        this.userOrder.payment = this.paymentType;

        //建工需求，单位名称必须填写
        if (this.show_company_name_input) {
          if (!this.input_company_name || this.input_company_name == '') {
            this.$Toast.fail("单位名称必须填写");
            return;
          }
        }

        //瑞金需求，选择支付选项
        if (this.show_payment_options) {
          if (!this.input_payment_selection || this.input_payment_selection == '') {
            this.$Toast.fail("请选择支付选项");
            return;
          }
        }
        this.order_extra_data.flag_add_item = this.flag_add_item ? '1' : '0';
        this.order_extra_data.company_name = this.input_company_name;
        this.order_extra_data.payment_option = this.input_payment_selection;
        this.userOrder.extraData = JSON.stringify(this.order_extra_data);


        this.isLoading = true;
        console.log(this.userOrder);
        order_api.saveOrder(this.userOrder).then(res => {
          console.log(res);
          if (res.code == 200) {
            //跳转到支付页
            if (res.data && res.data.tradeUrl && res.data.tradeUrl !== '') {
              window.location.href = res.data.tradeUrl;
            } else {
              this.$router.replace({
                name: "orderSuccess",
                params: this.userOrder
              });
            }
          } else {
            this.$Dialog.alert({
              title: '预约失败',
              message: res.msg,
            }).then(() => {
              // on close
            });
            // this.$toast.fail(res.msg);
          }

          this.isLoading = false;
        })
      },
      selectDate() {
        var packageId = this.customized ? this.customizedProject.packageId.toString() : this.package.xh.toString();
        var items = [];
        if (this.customized) {
          this.customizedProject.packageItems.forEach(it => {
            items.push(it.id.toString());
          });
          this.customizedProject.addItems.forEach(it => {
            items.push(it.id.toString());
          });
        } else {
          this.package.items.forEach(it => {
            items.push(it.xh.toString());
          });
        }
        this.scheduleQueryParam = {
          hospId: this.$route.query.hospid,
          examTypeId: '',
          packageId: packageId,
          items: items.join('|'),
          age: this.getAge(this.userProfile.birth),
          sex: this.userProfile.sex,
          total: this.totalAmount,
          startDate: moment().add(1, 'days').format("YYYY-MM-DD"), //todo
          endDate: moment().add(30, 'days').format("YYYY-MM-DD"),
        }
        sch_api.getSchedule(this.scheduleQueryParam).then(res => {
          this.daySchedules = res;
          this.datePopup = true;
          this.showCalendar = true;
        })
      },
      onSelectDay(value) {
        console.log(value);
        var dateValue = moment(value).format("YYYY-MM-DD");
        var selectedDate = this.daySchedules.find(it => it.dayValue == dateValue);
        if (selectedDate.orderable) {
          this.dateDisableReason = "";
          this.orderDate = dateValue;
          this.timeRanges = this.daySchedules.find(it => it.dayValue == this.orderDate).timeRanges;
          //重置已选时间段
          this.orderTime = null;
        } else {
          this.dateDisableReason = selectedDate.reason;
          this.orderDate = null;
          this.orderTime = null;
        }
      },
      setOrderTime(time) {
        //横向滚动
        let idx = this.timeRanges.indexOf(time);
        let dom = this.$refs.timeItems[idx];
        dom.scrollIntoView({
          behavior: 'smooth'
        });
        if (time.limitNum == 0 || time.limitNum <= time.orderNum || !time.orderable) {
          return;
        } else {
          this.orderTime = time;
        }
      },
      setOrderDateTime() {
        if (!this.orderDate || this.orderDate == "") {
          this.$Toast.fail("请选择体检日期");
          return;
        } else if (!this.orderTime || !this.orderTime.timeRangeName) {
          this.$Toast.fail("请选择体检时段");
          return;
        } else {
          this.showCalendar = false;
        }
      },
      formatter(day) {
        const month = day.date.getMonth() + 1;
        const date = day.date.getDate();
        const weekday = day.date.getDay();
        var schDate = this.daySchedules.find(it => it.dayValue == moment(day.date).format("YYYY-MM-DD"));
        if (schDate) {
          if (schDate.isOpen == false) {
            day.topInfo = '休';
            day.type = "disabled";
          } else if (!schDate.orderable) {
            //day.type = "disabled";
            if (schDate.limitNumAm + schDate.limitNumPm == 0) {
              day.topInfo = "不开放";
            } else {
              day.topInfo = "约满";
            }
          }
        } else {
          day.type = "disabled";
        }

        return day;
      },

    },

  };
</script>